/**
 * content语言代码正反格式化（下划线替换成横杠或者从合法语言代码逆转为content语言代码）
 * @param langStr 带横杠'-'或者下划线'_'的语言代码
 * @param isReverse 是否逆转
 * @returns 格式化结果字符串
 */
export function useFormatContentLang(langStr: string, isReverse?: boolean): string {
  if (isReverse) return langStr.replace(/-/g, '_')
  return langStr.replace(/_/g, '-')
}
